const common = {
  // Nav
  nav_home: 'Home',
  nav_books: 'Libri',
  nav_courses: 'Corsi',
  nav_mentorship: 'Mentoria SÍLEX',
  nav_webinars: 'Webinar',
  nav_about: 'Chi siamo',
  nav_contact: 'Contatto',
  nav_links: 'Link',
  nav_enter: 'Accedi',
  nav_my_courses: 'I miei corsi',
  nav_community: 'Community',
  nav_ranking: 'Classifica',
  nav_certificates: 'Certificati',
  // Auth
  auth_login_title: 'Accedi al tuo account',
  auth_login_subtitle: 'Accedi con email o social network',
  auth_register_title: 'Crea il tuo account',
  auth_register_subtitle: 'Registrati per accedere ai corsi',
  auth_forgot_title: 'Recupera la password',
  auth_forgot_subtitle: 'Ti invieremo un link alla tua email',
  auth_tab_login: 'Accedi',
  auth_tab_register: 'Crea account',
  auth_email: 'E-mail',
  auth_password: 'Password',
  auth_name: 'Nome completo',
  auth_confirm_password: 'Conferma password',
  auth_forgot_link: 'Ho dimenticato la password',
  auth_btn_login: 'Accedi con Email',
  auth_btn_register: 'Crea account gratuito',
  auth_btn_forgot: 'Invia link di recupero',
  auth_or: 'o continua con',
  auth_or_register: 'o registrati con',
  auth_google: 'Continua con Google',
  auth_facebook: 'Continua con Facebook',
  auth_apple: 'Continua con Apple',
  auth_back_login: '← Torna al login',
  auth_terms: 'Accedendo, accetti i nostri',
  auth_terms_link: 'Termini di utilizzo',
  auth_privacy_link: 'Informativa sulla privacy',
  auth_and: 'e',
  // Livros page
  livros_hero_badge: 'Biblioteca Completa',
  livros_hero_title: 'Ebook e Libri',
  livros_hero_subtitle: 'Conoscenza che trasforma. Scegli il tuo prossimo libro e inizia il tuo viaggio di crescita.',
  livros_filter_all: 'Tutti',
  livros_filter_pdf: 'E-book PDF',
  livros_filter_print: 'Stampato',
  livros_search_placeholder: 'Cerca libro o argomento...',
  livros_btn_buy: 'Acquista Ora',
  livros_btn_amazon: 'Amazon',
  livros_btn_details: 'Vedi Dettagli',
  livros_pages: 'pag',
  livros_readers: 'lettori',
  livros_cta_title: 'Accesso a tutti i libri?',
  livros_cta_subtitle: 'Abbonati a SB Family e ottieni accesso illimitato all\'intera biblioteca + corsi + mentoring di gruppo.',
  livros_cta_btn: 'Scopri l\'abbonamento',
  livros_stat_books: 'Libri Pubblicati',
  livros_stat_readers: 'Lettori Soddisfatti',
  livros_stat_rating: 'Valutazione Media',
  livros_stat_editions: 'Edizioni Riviste',
  // Language
  lang_label: 'Lingua',
  lang_pt: 'Português',
  lang_es: 'Español',
  lang_en: 'English',
  lang_fr: 'Français',
  lang_de: 'Deutsch',
  lang_it: 'Italiano',
  lang_ja: '日本語',
};

export default common;
